import "../Css/custom-style.css";
import img3 from "../Images/phone-14.png";
import img4 from "../Images/vec.png";
import Navbar from "../Component/Navbar";
import Footer from "../Component/Footer";
import Loader from "../Component/Loader";
import { useState } from "react";
import emailjs from "emailjs-com";

const HomePage = ({ data, loading }) => {
  const [subscribe, setSubscribe] = useState("");
  const [contactUsText, setContactUsText] = useState("");
  const maxLen = 30;
  

  const HandleSubmit = (e) => {
    e.preventDefault();

    setSubscribe("");

    emailjs.sendForm(process.env.REACT_APP_ServiceID, process.env.REACT_APP_TemplateID, e.target, process.env.REACT_APP_ApiKey).then(
      (result) => {
        setContactUsText("Thank you for contacting us!");
      },
      (error) => {
        alert("Failed to send message.");
        setContactUsText("Failed to send message.");
        console.error(error.text);
      }
    );

    e.target.reset();
  };

  if (loading || !data) {
    return <Loader />;
  }

  return (
    <>
      <Navbar apidata={data} />
      <section className="PROJECTW">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="background-im">
                <div className="row">
                  <div className="col-lg-12">
                    <p className="project-p-size">{data?.SectionOne?.heading}</p>
                  </div>
                </div>
                <div className="row cus-row">
                  <div className="col-lg-5">
                    <div className="left-project">
                      <p className="project-p-1">{data?.SectionOne?.headingOne}</p>
                      <p className="project-p-2">{data?.SectionOne?.paragraphOne}</p>
                      <ul className="sounds-ul">
                        <li>
                          <p>{data?.SectionOne?.paragraphTwo}</p>
                        </li>
                        <li>
                          <a className="zoom" href="#footer">
                            {data?.SectionOne?.buttonOne}
                          </a>
                          <a className="zoom" href="#footer">
                            {data?.SectionOne?.buttonTwo}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-7">
                    <div className="right-project">
                      <img className="creative-reel" src={data?.SectionOne?.image} alt="Creative Reel" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="yellow-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="yellow-content">
                <p className="yellow-p">
                  {data?.SectionTwo?.paragraphOne &&
                    (() => {
                      const text = data.SectionTwo.paragraphOne.trim();
                      const words = text.split(" ");

                      const firstTwoWords = words.slice(0, 2).join(" ");
                      const remaining = words.slice(2).join(" ");

                      return (
                        <p>
                          <strong>{firstTwoWords}</strong> {remaining}
                        </p>
                      );
                    })()}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="yellow-2">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="under-flex">
                  <ul>
                    <li>
                      <p>{data?.SectionTwo?.paragraphTwo}</p>
                    </li>
                    <li>
                      <a className="zoom" href="#footer">
                        {data?.SectionTwo?.button}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="instant">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="background-img-sec">
                <div className="right-side-img">
                  <img src={img3} className="phone-14-class" alt="Phone 14" />
                </div>
                <div className="instant-content">
                  <ul className="instant-ul">
                    <li>
                      <img src={img4} className="vec-img" alt="Vector Icon" />

                      <p className="vec-p">
                        {data?.SectionThree?.headingOne}
                        <br />
                        {data?.SectionThree?.headingTwo}
                      </p>
                    </li>
                    <li>
                      <img src={img4} className="vec-img" alt="Vector Icon" />
                      <p className="vec-p">{data?.SectionThree?.headingThree}</p>
                    </li>
                    <li>
                      <img src={img4} className="vec-img" alt="Vector Icon" />
                      <p className="vec-p">
                        {data?.SectionThree?.headingFour}
                        <br />
                        {data?.SectionThree?.headingFive}
                      </p>
                    </li>
                  </ul>
                  <p className="vec-p-1">{data?.SectionThree?.paragraph}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="join" id="subscribe">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <form className="join-under" onSubmit={HandleSubmit}>
                <ul>
                  <li>
                    <p className="join-p">{data?.SectionFour?.title}</p>
                  </li>
                  <li>
                    <input type="email" maxLength={maxLen} name="email" required value={subscribe} className="input-join" onChange={(e) => setSubscribe(e.target.value)} placeholder="Your email" />
                     <span
        style={{
     marginLeft:"10px",
          fontSize: "12px",
          color: subscribe.length === maxLen ? "red" : "gray"
        }}
      >
        {subscribe.length} / {maxLen}
      </span>
                  </li>
                  <li>
                    <button className="subscribe-bt zoom">{data?.SectionFour?.button}</button>
                  </li>
                </ul>
              </form>
            </div>
            {contactUsText && (
              <p className="my-4" style={{ border: "3px solid #46b450", width: "100%", padding: "8px" }}>
                {contactUsText}
              </p>
            )}
          </div>
        </div>
      </section>

      <section className="logo-section">
        <div className="height-30"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="logo-under">
                <ul>
                  <li>
                    <img src={data?.SectionFive?.imageOne} alt="Logo 1" />
                  </li>
                  <li>
                    <img src={data?.SectionFive?.imageTwo} alt="Logo 2" />
                  </li>
                  <li>
                    <img src={data?.SectionFive?.imageThree} alt="Logo 3" />
                  </li>
                  <li>
                    <img src={data?.SectionFive?.imageFour} alt="Logo 4" />
                  </li>
                  <li>
                    <img src={data?.SectionFive?.imageFive} alt="Logo 5" />
                  </li>
                  <li>
                    <img src={data?.SectionFive?.imageSix} alt="Logo 6" />
                  </li>
                  <li>
                    <img src={data?.SectionFive?.imageSeven} alt="Logo 7" />
                  </li>
                  <li>
                    <img src={data?.SectionFive?.imageEight} alt="Logo 8" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer apidata={data} />
    </>
  );
};

export default HomePage;
